import axios from 'axios';
import CustomSelect from './custom-select';
import FileInput from './file';
import Observer from 'common/scripts/observer';
import {Utils} from 'common/scripts/utils';
import {YANDEX_METRIC_ID} from 'common/scripts/constants';

const observer = new Observer();

class Form {
    constructor() {
        this.inputList = [];
    }

    // eslint-disable-next-line max-statements
    init(options) {
        this.wrapper = options.target;
        this.popupInstance = options.popupInstance || null;
        this.form = options.target.querySelector('form');
        this.isVaildation = 'validate' in this.form.dataset;
        this.successMessage = options.successMessage;
        this.action = this.form.getAttribute('action');
        this.messageBot = this.form.querySelector('[name="message_bot"]');
        this.successCallback = options.successCallback || null;
        this.readyClass = 'is-ready';
        this.showClass = 'is-active';
        this.errorClass = 'is-error';
        this.disabledClass = 'is-disabled';
        this.select = Array.from(this.form.querySelectorAll('.j-form__select'));
        this.files = Array.from(this.form.querySelectorAll('.j-form__file'));
        // Проверяем - надо ли схлопывать форму после ее отправки
        this.collapseForm = this.form.classList.contains('j-form-collapse');
        // Проверяем - есть ли прелоадер отправки данных у формы?
        this.isPreloader = this.form.classList.contains('j-form-with-preloader') || null;
        this.preloader = this.wrapper.querySelector('.j-form-preloader');
        // Если форма уже отправляется (Todo где-то лишние вызовы, смотреть вызовы _send)
        this.isSending = false;

        this._getElements();
        this._subscribes();
        this._bindEvents();
        this._setHiddenUrl();
    }

    send() {
        this._send();
    }

    /**
     * Метод получает дом элементы.
     * @private
     */
    _getElements() {
        this.formContent = this.form.querySelector('.j-form-content');
        this.submit = this.form.querySelector('.j-form-submit');
        this.submitText = this.submit.querySelector('span');
        this.submitSendText = this.submit.dataset.sendText;
        this.submitSuccessText = this.submit.dataset.successText;
        this.submitErrorText = this.submit.dataset.errorText;
        this.formId = this.form.getAttribute('id') || '';
        this.ymGoalName = this.form.dataset.ymGoal || false;
        // this.rePublicKey = this.form.dataset.republickey || false;
        this.agreementCheckbox = this.form.querySelector('.agreement-checkbox');

        if (this.successMessage) {
            this.successMessageWrap = this.wrapper.querySelector('.j-form-success');
        }

        this.errorMessageWrap = this.wrapper.querySelector('.j-form-error');
        this.errorText = this.errorMessageWrap?.querySelector('.j-server-error-response');

        if (this.agreementCheckbox) {
            this._disableSubmit();
        }
    }

    _disableSubmit() {
        this.submit.disabled = !this.agreementCheckbox.checked;

        this.agreementCheckbox.addEventListener('change', () => {
            this.submit.disabled = !this.agreementCheckbox.checked;
        });
    }

    /* eslint-disable max-lines-per-function */
    _subscribes() {
        if (this.isVaildation) {
            observer.subscribe('formIsValid', (form) => {
                if (form === this.form) {
                    this._send();
                }
            });
        }

        if (this.select) {
            observer.subscribe('custom-select-hide-all', (items) => {
                items.forEach((item) => {
                    const additionalItemClass = item.dataset.additional;

                    if (!additionalItemClass) {
                        return;
                    }

                    const additionalItems = Array.from(this.form.querySelectorAll(`.${additionalItemClass}`));

                    additionalItems.forEach((element) => {
                        element.classList.remove('is-active');
                        element.classList.add('is-hide');
                    });
                });
            });

            observer.subscribe('custom-select-changed', (item) => {
                const additionalItemClass = item.dataset.additional;

                // Если класс для поиска элементов отсутствует - выходим
                if (!additionalItemClass) {
                    return;
                }

                // Находим все элементы
                const additionalItems = Array.from(this.form.querySelectorAll(`.${additionalItemClass}`));

                additionalItems.forEach((element) => {
                    // Находим инпут внутри элемента
                    const input = element.querySelector('input');

                    if (item.dataset.show) {
                        if (element.classList.contains('is-hide')) {
                            element.classList.remove('is-hide');
                            element.classList.add('is-active');

                            if (input && input.type !== 'checkbox') {
                                if (input.classList.contains('validate-input-success')) {
                                    input.classList.remove('validate-input-success');
                                }

                                input.value = null;
                            }
                        }
                    } else {
                        if (element.classList.contains('is-active')) {
                            element.classList.add('is-hide');
                            element.classList.remove('is-active');
                        }

                        if (input && input.type !== 'checkbox') {
                            input.value = 'Не требуется для заполнения';
                        }
                    }
                });
            });
        }
    }
    /* eslint-enable max-lines-per-function */

    /**
     * Метод навешивает обработчики событий.
     * @private
     */
    _bindEvents() {
        // if (this.rePublicKey) {
        //     this._initRecaptcha();
        // }

        if (!this.isVaildation) {
            if (this.submit) {
                this.submit.addEventListener('click', (event) => {
                    event.preventDefault();
                    this._send();
                });
            }
        }

        const elasticTextarea = Array.from(this.form.querySelectorAll('.j-elastic-textarea'));

        if (elasticTextarea.length) {
            elasticTextarea.forEach((textarea) => {
                this._resizeTextarea(textarea);
            });
        }

        this.select.forEach((select) => {
            const newSelect = new CustomSelect({
                elem: select
            });

            newSelect.init();
        });

        this.files.forEach((file) => {
            const newFile = new FileInput({
                elem: file
            });

            newFile.init();
        });
    }

    /**
     * Метод оптправляет данные на сервер.
     * @private
     */

    // eslint-disable-next-line max-lines-per-function
    _send() {
        if (this._isAllReady() || this.isSending) {
            return;
        }

        this._insertAntiSpam();
        this.formData = new FormData(this.form);
        this.formDataObject = {};
        this.formData.forEach((value, key) => {
            this.formDataObject[key] = value;
        });
        // Если есть файл - прикрепляем его на отправку
        if (this.files.length) {
            this.files.forEach((item) => {
                const fileField = item.querySelector('.j-form__file-input');
                const file = fileField.files[0];
                const fieldName = fileField.getAttribute('name');

                if (file) {
                    this.formData.append(fieldName, file);
                }
            });
        }
        this._insertButtonText(this.submitSendText);

        if (this.collapseForm) {
            this.form.classList.add('is-collapsed');
        }

        if (this.isPreloader) {
            this._preloaderShow(true);
        }

        this.isSending = true;

        axios.post(this.action, this.formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                const status = response.data.success;

                if (!status) {
                    throw new Error('Ошибка на сервере');
                }
                this._sendIsSuccess(response.data.data.message);
                if (this.successCallback) {
                    this.successCallback(response.data);
                }
                // this._initRecaptcha();
            })
            .catch((err) => {
                const errorsData = err.response.data.errors;

                this._sendIsError(errorsData ? errorsData : null);
                // this._initRecaptcha();
                console.error(err);
            })
            .finally(() => {
                this.isSending = false;
            });
    }

    // _initRecaptcha() {
    //     const tokenInput = this.wrapper.querySelector('[name="token-re"]');
    //
    //     if (!tokenInput) {
    //         return;
    //     }
    //
    //     if (window.grecaptcha) {
    //         window.grecaptcha.ready(() => {
    //             window.grecaptcha.execute(this.rePublicKey, {action: 'page'}).then((token) => {
    //                 tokenInput.value = token;
    //             });
    //         });
    //     }
    // }

    _isAllReady() {
        return this.wrapper.classList.contains(this.readyClass);
    }

    /**
     * Показывает или скрывает прелоадер
     * @param {boolean} switcher - включает или выключает прелоадер
     */
    _preloaderShow(switcher) {
        // eslint-disable-next-line
        switcher ? this.preloader.classList.add('is-active') : this.preloader.classList.remove('is-active');
    }

    /**
     * Метод вызывается при успешной отправке запроса.
     * @param {text} message - сообщение в ответе с сервера
     * @private
     */
    _sendIsSuccess(message = '') {
        this.errorMessageWrap.classList.remove(this.showClass);
        this.submit.classList.remove(this.errorClass);

        if (this.isPreloader) {
            this._preloaderShow(false);
        }

        this._showSuccessMessage(message);
        this._insertButtonText(this.submitSuccessText);
        this.submit.classList.add(this.disabledClass);
        this._sendMetricGoal();
    }

    /**
     * Метод вызывается при ошибке отправки запроса.
     * @param {object} message - объект с данными ошибки
     * @private
     */
    _sendIsError(message = null) {
        this._insertButtonText(this.submitErrorText);
        this.submit.classList.add(this.errorClass);

        if (this.isPreloader) {
            this._preloaderShow(false);
        }

        let errorMessage = '';

        if (message) {
            for (const key in message) {
                if ({}.hasOwnProperty.call(message, key)) {
                    errorMessage = `${errorMessage} ${message[key]}<br />`;
                }
            }
        }

        this._showErrorMessage(errorMessage);
    }

    /**
     * Показывает сообщение об успешной отправкой формы.
     * @param {text} message - сообщение в ответе с сервера
     * @private
     */
    _showSuccessMessage(message) {
        this.wrapper.classList.add(this.readyClass);
        this.successMessageWrap.classList.add(this.showClass);

        if (message !== '') {
            this.successMessageWrap.querySelector('.j-server-success-response').innerText = message;
        }

        // Расскоментировать если понадобится скрытие формы, но необходимо учесть особенности форм подписки, формы на странице контактов и Линии доверия
        // if (!this.form.classList.contains('form__subscribe')) {
        //     Utils.hide(this.form);
        // }

        observer.publish('successForm');
    }

    /**
     * Показывает сообщение об ошибке
     * @param {string} message - строка с данными ошибки
     * @private
     */
    _showErrorMessage(message) {
        this.wrapper.classList.add(this.readyClass);
        this.successMessageWrap.classList.remove(this.showClass);
        this.errorMessageWrap.classList.add(this.showClass);
        this.errorText.dataset.default = this.errorText.dataset.default ? this.errorText.dataset.default : '';
        this.errorText.innerHTML = message.length ? message : this.errorText.dataset.default;

        // Расскоментировать если понадобится скрытие формы, но необходимо учесть особенности форм подписки, формы на странице контактов и Линии доверия
        // if (!this.form.classList.contains('form__subscribe')) {
        //     Utils.hide(this.form);
        // }

        setTimeout(() => {
            this.wrapper.classList.remove(this.readyClass);
            this.errorMessageWrap.classList.remove(this.showClass);

            this.form.classList.remove('is-collapsed');
        }, 3000);

        observer.publish('errorForm');
    }

    /**
     * Метод вставляет текст в кнопку сабмит.
     * @param {string} text - необходимый текст.
     * @private
     */
    _insertButtonText(text) {
        Utils.clearHtml(this.submitText);
        Utils.insetContent(this.submitText, text);
    }

    /**
     * Метод вставляет скрытое поле с антиспамом
     */
    _insertAntiSpam() {
        if (this.messageBot) {
            const minRandom = 1;
            const maxRandom = 10;

            this.messageBot.value = `nospam ${Utils.random(minRandom, maxRandom)}`;
        }
    }

    /**
     * При необходимости устанавливает текущий url в скрытый инпут
     * @private
     */
    _setHiddenUrl() {
        const input = this.form.querySelector('input[name=url]');

        if (input) {
            input.value = window.location.href;
        }
    }

    /**
     * Автоизменение высоты текстового поля при заполнении
     * @param {object} textarea - элемент содержащий текстовое поле
     */
    _resizeTextarea(textarea) {
        const inputArea = textarea.querySelector('textarea');

        if (inputArea) {
            inputArea.addEventListener('keyup', () => {
                inputArea.style.height = `${inputArea.scrollHeight}px`;
            });
        }
    }

    _sendMetricGoal() {
        if (!this.ymGoalName || !window.ym) {
            return;
        }

        window.ym(YANDEX_METRIC_ID, 'reachGoal', this.ymGoalName);
    }
}

export default Form;
